<template>
  <div>
    <div v-if="auctions.count == 0">No active auctions</div>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4">
          <strong>Announced or active auctions</strong>
        </h5>

        <a-table :columns="columns" :dataSource="auctions">
          <router-link
            :to="'/auctions/' + record.id + '/live'"
            slot="id"
            slot-scope="text, record"
          >
            <a href="javascript: void(0);" class="btn btn-sm btn-light">{{
              text
            }}</a>
          </router-link>

          <span slot="status" slot-scope="text" :class="statusClasses(text)">{{
            text
          }}</span>

          <span slot="action" slot-scope="record">
            <a-space :space="16">
              <router-link :to="'/auctions/' + record.id + '/live'">
                <a-button type="primary" size="small"
                  ><i class="fe fe-arrow-up-right mr-2" />
                  Open
                </a-button>
              </router-link>
            </a-space>
          </span>

          <span slot="startsAt" slot-scope="text">{{
            moment(text).format('DD/MM/YYYY HH:mm')
          }}</span>
          <span slot="endsAt" slot-scope="text">{{
            moment(text).format('DD/MM/YYYY HH:mm')
          }}</span>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import { AuctionService } from '@/services/api'
import { statusClasses } from '@/utilities'
import { Space } from 'ant-design-vue'

import Vue from 'vue'

Vue.use(Space)

// import { dateStringSorter, stringSorter } from '@/utilities'
import moment from 'moment'

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    scopedSlots: { customRender: 'id' },
  },
  {
    title: 'Type',
    dataIndex: 'type',
  },
  {
    title: 'Auction name',
    dataIndex: 'name',
  },
  {
    title: 'Start date',
    dataIndex: 'startsAt',
    scopedSlots: { customRender: 'startsAt' },
  },
  {
    title: 'End date',
    dataIndex: 'endsAt',
    scopedSlots: { customRender: 'endsAt' },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: 'Action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  components: {},
  data() {
    return {
      loading: false,
      columns,
      auctions: [],
    }
  },
  methods: {
    moment,
    statusClasses,
    fetchAuctions() {
      this.loading = true
      AuctionService.getActiveAuctions()
        .then((response) => {
          this.auctions = response.data.data.map((row) =>
            Object.assign({}, { key: row.id }, row)
          )
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = true
        })
    },
  },
  mounted() {
    this.fetchAuctions()
    this.interval = setInterval(() => this.fetchAuctions(), 5000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
}
</script>
